import * as busyIndicatorSelectors from './busyIndicator.selectors'
import BusyIndicator from './BusyIndicator'
import slice from './busyIndicator.slice'
import * as constants from './busyIndicator.constants'

export const {
	name,
	actions: { incrementBusyIndicator, decrementBusyIndicator },
	reducer,
} = slice

export const { getGlobalBusyIndicator, getNamedBusyIndicator } =
	busyIndicatorSelectors

export const { REGIONS } = constants

export default BusyIndicator
